// Mapa módulo -> ruta, en el MISMO orden del sidebar (AdminLayout).
// Se usa para decidir el aterrizaje tras login según los permisos del rol.
const MODULO_RUTA = [
  ['dashboard', '/admin/dashboard'],
  ['reclamos', '/admin/reclamos'],
  ['resoluciones', '/admin/resoluciones'],
  ['proyectos', '/admin/proyectos'],
  ['usuarios', '/admin/usuarios'],
  ['roles', '/admin/roles'],
  ['empresa', '/admin/empresa'],
  ['empresas', '/admin/empresas'],
  ['auditoria', '/admin/auditoria'],
  ['ca_tickets', '/admin/centro-ayuda/tickets'],
  ['ca_configuracion', '/admin/centro-ayuda/configuracion'],
  ['ca_estadisticas', '/admin/centro-ayuda/estadisticas'],
  ['ca_auditoria', '/admin/centro-ayuda/auditoria'],
  ['cx_journey', '/admin/experiencia/journey'],
  ['cx_clientes', '/admin/experiencia/clientes'],
  ['cx_analytics', '/admin/experiencia/analytics'],
  ['cx_configuracion', '/admin/experiencia/configuracion'],
];

// Devuelve la primera ruta que el usuario puede ver según su matriz de permisos.
// Si no hay matriz cargada (usuarios legacy), cae a /admin/dashboard.
export function primeraRutaPermitida(user) {
  const permisos = user?.permisos;
  if (permisos) {
    for (const [modulo, ruta] of MODULO_RUTA) {
      if (permisos[modulo]?.ver === true) return ruta;
    }
    // Con matriz pero sin ningún módulo visible: no forzar dashboard.
    return '/admin/centro-ayuda/tickets';
  }
  return '/admin/dashboard';
}

// True si el usuario puede ver un módulo concreto (con fallback a rol legacy).
export function puedeVerModulo(user, modulo, rolesLegacy = []) {
  const permisos = user?.permisos;
  if (permisos && permisos[modulo]) return permisos[modulo].ver === true;
  return rolesLegacy.includes(user?.rol);
}

// True si el usuario tiene una acción concreta (ver/crear/editar/eliminar) en un módulo.
export function tienePermiso(user, modulo, accion) {
  const permisos = user?.permisos;
  if (permisos && permisos[modulo]) return permisos[modulo][accion] === true;
  return false;
}
